import { render, staticRenderFns } from "./BackgroundBase.vue?vue&type=template&id=8f0cebdc&scoped=true&"
import script from "./BackgroundBase.vue?vue&type=script&lang=js&"
export * from "./BackgroundBase.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundBase.vue?vue&type=style&index=0&id=8f0cebdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0cebdc",
  null
  
)

export default component.exports